var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.87 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.93 15 1.16 9.44A5.82 5.82 0 0 1 0 5.93C0 2.66 2.66 0 5.93 0a5.93 5.93 0 0 1 5.93 5.93c0 1.27-.4 2.5-1.16 3.51zm0-11.9a2.827 2.827 0 0 0-2.85 2.81 2.827 2.827 0 0 0 2.81 2.85c1.56.01 2.84-1.24 2.85-2.81v-.02c0-1.56-1.25-2.82-2.81-2.83"
  })));
};
export default SvgLocation;